import { PlainButton, TextInput, TableGridColumn } from "@jugl-web/ui-kit";
import { cx, TFunction } from "@jugl-web/utils";
import { normalizeVariableName } from "../../../../utils/variableName";
import { ReactComponent as TrashIcon } from "./assets/trash.svg";

export type DataInputItem = {
  id: string;
  name: string;
  description: string;
};

const tdOverflowVisibleClassName = "[&>div]:!overflow-visible";

export const buildDataInputTableColumns = (
  t: TFunction,
  onChange: (next: DataInputItem) => void,
  onDelete: (id: string) => void
): TableGridColumn<DataInputItem>[] => [
  {
    id: "name",
    title: t({
      id: "cx-actions-page.name",
      defaultMessage: "Name",
    }),
    grow: true,
    style: { minWidth: 180 },
    headerStyle: { minWidth: 180 },
    className: tdOverflowVisibleClassName,
    content: (item) => (
      <div className="w-full min-w-[180px]">
        <TextInput
          placeholder={t({
            id: "cx-actions-page.enter-name-placeholder",
            defaultMessage: "Enter name",
          })}
          value={item.name}
          onChange={(event) =>
            onChange({
              ...item,
              name: normalizeVariableName(event.target.value),
            })
          }
          classNames={{ inputClassName: "h-[50px] py-0" }}
        />
      </div>
    ),
  },
  {
    id: "description",
    title: t({
      id: "cx-actions-page.description",
      defaultMessage: "Description",
    }),
    grow: true,
    style: { minWidth: 220 },
    headerStyle: { minWidth: 220 },
    className: tdOverflowVisibleClassName,
    content: (item) => (
      <div className="w-full min-w-[220px]">
        <TextInput
          placeholder={t({
            id: "cx-actions-page.enter-description-placeholder",
            defaultMessage: "Enter description",
          })}
          value={item.description}
          onChange={(event) =>
            onChange({ ...item, description: event.target.value })
          }
          classNames={{ inputClassName: "h-[50px] py-0" }}
        />
      </div>
    ),
  },
  {
    id: "action",
    title: t({
      id: "cx-actions-page.action",
      defaultMessage: "Action",
    }),
    width: 72,
    headerClassName: "[&>div]:justify-center",
    className: cx("[&>div]:justify-center", tdOverflowVisibleClassName),
    content: (item) => (
      <div className="flex w-full justify-center">
        <PlainButton
          type="button"
          onClick={() => onDelete(item.id)}
          className="flex h-8 w-8 items-center justify-center"
        >
          <TrashIcon />
        </PlainButton>
      </div>
    ),
  },
];
